<template>

  <div>
    <section class="section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-3 bg-gradient-default">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pt-lg ">

        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3 text-white">Pricing and the Save System</h2>
          </div>
        </div>
      </div>
    </section>
    <section class="section">
      <div class="container">
        <div class="row justify-content-center mt--100">
          <div class="col-lg-12">
            <card gradient="white" shadow>
              <p>{{post.text1}}</p>
              <p>{{post.text2}}</p>
              <p>{{post.text3}}</p>
              <p>{{post.text4}}</p>
              <p style="font-weight: bold; line-height: normal; text-decoration: underline">Average amount of time needed to complete:</p>
              <p style="">
                <a
                    href="https://offthecouchgames.com/apartment"
                ><span style="font-weight: bold">Ch. 1: Apartment</span> </a>
                - 105 minutes
              </p>
              <p style="">
                <a
                    href="https://offthecouchgames.com/gallery"
                ><span style="font-weight: bold">Ch. 2: Art Gallery</span> </a>
                - 90 minutes
              </p>
              <p style="">
                <a
                    href="https://offthecouchgames.com/morgue"
                ><span style="font-weight: bold">Ch. 3: Morgue </span> </a>
                - 120 minutes
              </p>

              <div class="row justify-content-center mt-2">
                <div class="col">
                  <b-table :items="items" :fields="fields">
                    <template #head(number)="row">
                      <span style="font-size: small">Number of players</span>
                    </template>
                    <template #head(rate)="row">
                      <span  style="font-size: small">Rate per person, per hour</span>
                    </template>
                    <template #head(total_60)="row">
                      <span  style="font-size: small">Total: 60 minutes</span>
                    </template>
                    <template #head(total_90)="row">
                      <span  style="font-size: small">Total: 90 minutes</span>
                    </template>
                    <template #head(total_105)="row">
                      <span  style="font-size: small">Total: 105 minutes</span>
                    </template>
                    <template #head(total_120)="row">
                      <span  style="font-size: small">Total: 120 minutes</span>
                    </template>

                  </b-table>
                </div>
              </div>
              <p>{{post.text5}}</p>
              <ul class="list-unstyled mt-2">
                <li>
                  <div class="row">
                    <div class="col">
                      <span style="display: inline-block" >
                       <badge type="success" circle class="mr-3" icon="ni ni-email-83"></badge>

                      </span>
                      <span style="display: inline-block" >
                        <h6 class="mb-0"><a
                            href="mailto:contact@offthecouchgames.com"
                            v-on:click="tracker('Contact', 'Emailed contact', 'Link from Contact Info section on contact page')"
                        >{{contactInfo.email}}</a></h6>
                      </span>
                    </div>
                  </div>
                </li>
                <li class="mt-2">
                  <div class="row">
                    <div class="col">
                      <span style="display: inline-block" >
                        <badge type="success" circle class="mr-3" icon="ni ni-mobile-button"></badge>
                      </span>
                      <span style="display: inline-block" >
                        <h6 class="mb-0">{{contactInfo.phone}}</h6>
                      </span>
                    </div>
                  </div>
                </li>
                <li class="mt-2">
                  <div class="row">
                    <div class="col">
                      <span style="display: inline-block" >
                        <h6 class="mb-0">Or contact us through our
                        <a
                            href="https://offthecouchgames.com/contact"
                        >website</a>.
                        </h6>
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
              <p>Thank you for your support and we look forward to seeing you soon!</p>
              <p>Off The Couch</p>

            </card>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {BTable} from 'bootstrap-vue';

export default {
  name: "Pricing",
  components: {BTable},
  data () {
    return {
      post: {
        text1: "Off The Couch has created a unique pricing system for its immersive experiences to allow more flexibility in its designs as well as being the fairest to customers.",
        text2: "Every group is different, whether you have two players or six players, whether you’ve played thousands of games, or this is your first.  To create a game that is a set 60 minutes for all groups has become impossible.  You’re either going to get a game that is going to be too long or too short, too easy or too hard, and in the end you’re going to limit the possibilities to achieve a happy medium.  To change this way of thinking we created a “charge by time” model for all our experiences.",
        text3: "All our bookings are currently made based on the average time for that experience. If your time runs out before you complete the experience, we save your progress and on your next visit you resume from where you left off.  In the event you beat the experience in less time, any remaining time will be awarded to your customer account with us as a credit which can be applied to your next game or any item at Off the Couch.  You may also transfer your credits to other players if you like.",
        text4: 'Below you can find the current average time for each experience and a chart showing our current pricing.',
        text5: 'The chart above elaborates more on the pricing. Please do not hesitate to reach out to us using the information below if you have any questions.'
      },
      contactInfo: {
        address1: "555 Mowry Avenue",
        address2: "Fremont, CA 94536",
        phone: "+1 (408) 478-2341",
        email: "contact@offthecouchgames.com"
      },
      fields: ['number', 'rate', 'total_60', 'total_90', 'total_105', 'total_120'],
      items: [
        {
          number: 2,
          rate: '$66.00',
          total_60: '$132.00',
          total_90: '$198.00',
          total_105: '$231.00',
          total_120: '$264.00'
        },
        {
          number: 3,
          rate: '$54.00',
          total_60: '$162.00',
          total_90: '$243.00',
          total_105: '$283.50',
          total_120: '$324.00'
        },
        {
          number: 4,
          rate: '$48.00',
          total_60: '$192.00',
          total_90: '$288.00',
          total_105: '$336.00',
          total_120: '$384.00'
        },
        {
          number: 5,
          rate: '$44.00',
          total_60: '$220.00',
          total_90: '$330.00',
          total_105: '$385.00',
          total_120: '$440.00'
        },
        {
          number: 6,
          rate: '$40.00',
          total_60: '$240.00',
          total_90: '$360.00',
          total_105: '$420.00',
          total_120: '$480.00'
        }
      ]
    }
  },
  methods: {
    tracker(category, action, label) {
      this.$ga.event(category, action, label)
    }
  }
}
</script>

<style scoped>
.video {
  /*height: 100%;*/
  width: 100%;
  object-fit: fill;
  position: relative;
}

</style>
